import { FC } from "react";
import { useTheme } from "styled-components";
import { IAdsBillBoardNewProviderProps } from "./AdsBillBoardNewProvider";
import AdsBillBoardNewProvider from "./AdsBillBoardNewProvider";

const AdsBillBoardNewProviderShimmer: FC<IAdsBillBoardNewProviderProps> = (props) => {
  const { enable3rdParty,memberData, country } = useTheme();
  const allowedCountries = process.env.NEXT_PUBLIC_SMC_CAMPAIGN_ALLOWED_COUNTRIES
  if (memberData?.is_pro_buyer) return null;
  if (!enable3rdParty) return null;
  if (!allowedCountries?.split('|').includes(country)) return null;
  return <AdsBillBoardNewProvider {...props}/>;
};

export default AdsBillBoardNewProviderShimmer;
